import { nombreEspecialidad, useEspecialidades } from '@/features/preguntas/queries';

/** Especialidades agrupadas por especialidad (las subespecialidades dentro), como en el legacy. */
export function SelectorEspecialidad({
  valor,
  onCambio,
  vacio = 'Sin especialidad',
  requerido = false,
  deshabilitado = false,
  id,
}: {
  valor: number | null;
  onCambio: (id: number | null) => void;
  vacio?: string;
  requerido?: boolean;
  deshabilitado?: boolean;
  id?: string;
}) {
  const esp = useEspecialidades();
  const grupos = new Map<string, NonNullable<typeof esp.data>>();
  esp.data?.forEach((e) => grupos.set(e.name, [...(grupos.get(e.name) ?? []), e]));
  return (
    <select
      id={id}
      className="input-vidrio"
      value={valor ?? ''}
      required={requerido}
      disabled={deshabilitado}
      onChange={(e) => onCambio(e.target.value ? Number(e.target.value) : null)}
    >
      <option value="">{esp.isPending ? 'Cargando…' : vacio}</option>
      {[...grupos].map(([nombre, items]) =>
        items.length === 1 && !items[0]?.subspecialty ? (
          <option key={items[0]?.id} value={items[0]?.id}>
            {nombre}
          </option>
        ) : (
          <optgroup key={nombre} label={nombre}>
            {items.map((e) => (
              <option key={e.id} value={e.id}>
                {nombreEspecialidad(e)}
              </option>
            ))}
          </optgroup>
        ),
      )}
    </select>
  );
}
